module.exports = "/mobilee63c907447e4c529a909f4ae5ff2977d.svg";